<template>
  <div>
    <h4>General description</h4>
    <p>
      This corresponds to a non-coplanar orbit transfer where both semi-major
      axis and inclination can be simultaneously changed. When considering a
      change in inclination, an efficiency factor is taken into account to
      consider the fact that this manoeuvre is less efficient away from the
      orbital nodes. The length of the thrust arcs about the nodes is dictated
      by the duty cycle. More details on the duty cycle can be found in the
      associated tooltip in the "Edit Spacecraft" section.
    </p>
  </div>
</template>

<script>
export default {
  name: 'tooltipParametricOrbitalTransfer'
}
</script>
